import { render, staticRenderFns } from "./cfdeMechanismDiscovery.vue?vue&type=template&id=60b088aa&scoped=true"
import script from "./cfdeMechanismDiscovery.vue?vue&type=script&lang=js"
export * from "./cfdeMechanismDiscovery.vue?vue&type=script&lang=js"
import style0 from "./cfdeMechanismDiscovery.vue?vue&type=style&index=0&id=60b088aa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b088aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60b088aa')) {
      api.createRecord('60b088aa', component.options)
    } else {
      api.reload('60b088aa', component.options)
    }
    module.hot.accept("./cfdeMechanismDiscovery.vue?vue&type=template&id=60b088aa&scoped=true", function () {
      api.rerender('60b088aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/cfdeMechanismDiscovery.vue"
export default component.exports